import * as React from 'react';
import { checkSitePassword } from './src/lib/utils'
import PasswordProtect from './src/components/password-protect'
import "./src/css/general.css"
import "./src/css/block/cards.css"
import "@fontsource/jost" // example font import

export const wrapPageElement = () => {
  if( checkSitePassword() ) {
    return
  }

  return <PasswordProtect />
};
